import $ from "jquery"

function ellipsis() {

	var $ellipsisContainer = $('.js-ellipsis');

	if ($ellipsisContainer.length) {

		function calcWidthTextEllipsis() {
			var $liTotalWidth = 0;
			$(".js-ellipsis li:not('.u-text-ellipsis')").each(function( index ) {
				$liTotalWidth += $(this).outerWidth(true);
			});
            // 44 equals to padding left of last li
			$ellipsisContainer.find('.u-text-ellipsis').width($ellipsisContainer.outerWidth() - $liTotalWidth - 44);
		}
		calcWidthTextEllipsis();

		$(window).resize(function() {
		  calcWidthTextEllipsis();
		});
	}

}

export default ellipsis;